const APP = {
  BASE_API_URL: "https://api.strelasoft.com/api",
  //BASE_API_URL: "https://api.strelasoft.com/democrm/server.php/api",
  //BASE_API_URL: "http://localhost/nord-fx/api",
  ReCAPTCHA_KEY: "6LeqCi4pAAAAACJd5P-0DSOD3Z8HRVYalHvgIpuH",
}

export default APP
